import React from 'react'
import {
  PrescriptionPillViewInputPillContainer,
  PrescriptionRemoveIconButton,
} from './styledComponents'
import Close from '@mui/icons-material/Close'

export default function DefaultSelectedPillComponent({
  value,
  idx,
  getOptionValue,
  getLabel,
  onClickOption,
  onRemoveOption,
  selectedItemIndex,
  pillColor,
  highlightedPillColor,
}) {
  return (
    <PrescriptionPillViewInputPillContainer
      onClick={() => {
        onClickOption(value, idx)
      }}
      selected
      highlighted={selectedItemIndex === idx}
      selectedColor={pillColor}
      highlightedColor={highlightedPillColor}
      key={`${idx}-${getOptionValue(value)}`}
    >
      <span>{getLabel(value)}</span>{' '}
      <PrescriptionRemoveIconButton
        // onMouseDown={(e) => {
        //   e.stopPropagation()
        //   setTempFoc(focused || false)
        // }} not working as expected
        onClick={(e) => {
          e.stopPropagation()
          onRemoveOption(value, idx)
        }}
        size="small"
      >
        <Close sx={{ fontSize: '1.3rem' }} />
      </PrescriptionRemoveIconButton>
    </PrescriptionPillViewInputPillContainer>
  )
}
